import './horizontalPartnerList.scss';
import React from 'react';
import { updatePartnerLike } from '@src/api/partner/partner';
import { HOSTNAME, isExternalUrl } from '@src/utils';
import { logEvent } from '@src/reactGa';
import { throttle } from 'lodash';

interface IHorizontalPartnerList {
	title?: string;
	list: {
		partnerUuid: string;
		coverUrl: string;
		region: string;
		partnerName: string;
		isLiked: boolean;
    isAdvertise?: boolean;
		type: number;
	}[];
	updateLikeOptimistic: (partnerUuid: string) => void;
}
export const updateLikeOptimistic = (list, partnerUuid: string) => {
	// 찜한 웨딩홀 낙관적 업데이트
	return list.map((item) => {
		if (item.partnerUuid === partnerUuid) {
			item.isLiked = !item.isLiked;
		}
		return item;
	});
}
let count = 0;
const HorizontalPartnerList = ({title, list, updateLikeOptimistic}: IHorizontalPartnerList) => {
	const onScrollList = throttle(_ => {
		logEvent('component_behavior', {
			component: 'HorizontalPartnerList',
			title: title,
			behavior: "scroll",
			content: ++count
		});
	}, 5000);
	const linkPartner = (item, type: number) => {
    const eventParam: any = {
			component: 'HorizontalPartnerList',
			title: title,
			behavior: "click",
			content: item.partnerName
		}
    if (item.isAdvertise) {
      eventParam.advertisement_campaign = "웨딩홀 전환";
      eventParam.advertisement_group = "주변 웨딩홀 추천";
      eventParam.advertisement_name = item.adName;
      eventParam.advertisement_code = item.adCode;
    }
		logEvent('component_behavior', eventParam);
		const partnerPath = type === 2 ? 'weddinghall' : 'partner';
		window.location.href = isExternalUrl(`${HOSTNAME}/${partnerPath}/${item.partnerUuid}`);
	}
	const updateLike = (partnerUuid: string, state: boolean) => {
		updatePartnerLike(partnerUuid, !state).then(() => {
			updateLikeOptimistic(partnerUuid);
		});
	}
	return (
		<div className="horizontal-partner-list">
			{title && <h3 className="horizontal-partner-list-title">{title}</h3>}
			{list.length === 0 && <div style={{height: 190}}></div>}
			<ul onScroll={onScrollList}>
				{list.map(item => (
				<li key={`horizontal-partner-list-${item.partnerUuid}-${title}`} onClick={() => linkPartner(item, item.type)}>
					<div 
						className="partner-thumb" 
						style={{backgroundImage: `url(${item.coverUrl})`}}
					>
						<i className={`icon ${item.isLiked ? "icon-heart-fill-r500" : "icon-heart-outline-white"}`} onClick={(e) => {
							e.stopPropagation();
							updateLike(item.partnerUuid, item.isLiked)
						}} />
					</div>
					<div>
						<span className="partner-sub">
              {item.region}
              {item.isAdvertise === true && 
              <span className="partner-advertise">광고</span>
              }
            </span>
						<span className="partner-name">{item.partnerName}</span>
					</div>
				</li>
				))}
			</ul>
		</div>
	);
};

export default HorizontalPartnerList;